// 培养方案项目所需所有的请求地址
export const pyfaUrls = {
  /**
   * 培养方案管理现象设置urls
   */
  pyfaglUrls: {
    // 分页查询成绩选项设置
    findPage: 'pyfa/kctx/getKctxs',
    // 保存
    save: 'pyfa/kctx/save',
    // 获取所有办学专业
    getAllBxzy: 'pyfa/bxzy/getAll',
    // 获取所有办学年级
    getAllBxnj: 'pyfa/bxnj/getAll',
    // 删除
    delById: 'pyfa/kctx/delById',
    // 复制培养方案
    copyKctx: 'pyfa/kctx/copyKctx',
    // 查询可以复制的课程体系
    getKctxByCanUse: 'pyfa/kctx/getKctxByCanUse',
    // 查询培养方案的详情
    getDetail: 'pyfa/kctx/getDetail',
    // 查询学生的培养方案
    getKctxByStuId: 'pyfa/kctx/getKctxByStuId',
  },
  /**
   * 培养方案学分设置urls
   */
  pyfaXfsz: {
    // 分页获取培养方案学分设置
    getXfszs: 'pyfa/xfsz/getXfszs',
    // 保存
    save: 'pyfa/xfsz/save',
    // 删除
    delById: 'pyfa/xfsz/delById',

    // 获取所有培养方案；
    getAllpyfa: 'pyfa/kctx/getAll',
    // 获取课程类型
    findByKclx: 'pyfa/kclx/getAllKclx',
  },
  /**
   * 培养方案学期计划urls
   */
  pyfaXqjh: {
    // 分页获取培养方案学期计划
    getByKctx: 'pyfa/kctxxqjh/getByKctx',
    // 删除
    delById: 'pyfa/kctxxqjh/delById',
    // 保存
    save: 'pyfa/kctxxqjh/save',
    // 获取学期
    getXq: 'pyfa/bxzy/getXqFromBxzy',
  },
  /**
   * 学期计划学分设置urls
   */
  xqjhXfsz: {
    // 分页查询学期计划学分设置
    getXqjhXfsz: 'pyfa/xqjhxfsz/getXqjhXfszs',
    // 获取所有学期计划
    getAllXqjh: 'pyfa/kctxxqjh/getAll',
    // 保存
    save: 'pyfa/xqjhxfsz/save',
    // 删除
    delById: 'pyfa/xqjhxfsz/delById',
    //根据培养方案ID查询学分计划
    selectXqjhXfszByKctxId: 'pyfa/xqjhxfsz/selectXqjhXfszByKctxId',
  },
  /**
   * 课程体系计划课程
   */
  kctxJhkc: {
    // 保存
    getKctxJhkcSave: 'pyfa/kctxjhkc/save',
    // 根据学期计划和课程类型查询信息
    findByXqjhAndKclx: 'pyfa/kctxjhkc/findByXqjhAndKclx',
    // 更新课程体系计划课程
    updateKctxjhkc: 'pyfa/kctxjhkc/updateKctxjhkc',
    // 根据课程体系、课程类型、课程性质查询信息
    findKctxjhkcByXqjhAndLx: 'pyfa/kctxjhkc/findKctxjhkcByXqjhAndLx',
    // 根据学期计划获取计划课程信息
    getKctxjhkcs: 'pyfa/kctxjhkc/getKctxjhkcs',
    // 删除
    delByKctxJhkc: 'pyfa/kctxjhkc/delById',
    // 根据学期计划获取课程信息
    getByXq: 'pyfa/kctxjhkc/getByXq',
    // 根据学期计划获取计划课程信息
    getByXqjh: 'pyfa/kctxjhkc/getByXqjh',
    pageKcxx: 'pyfa/kcxx/findPage',
  },
  /**
   * 计划课程课时类型
   */
  jhkckslx: {
    // 保存计划课程课时类型
    getJhkcKslxSave: 'pyfa/jhkckslx/save',
    // 分页查询计划课程课时类型
    getPageResult: 'pyfa/jhkckslx/getPageResult',
    // 删除
    delByJhkckslx: 'pyfa/jhkckslx/delete',
    // 查询计划课程课时类型
    findJhkckslx: 'pyfa/jhkckslx/findJhkckslx',
    // 查询全部课时类型
    getAllkslx: 'pyfa/kslx/getAll',
    // 查询全部教室信息类型
    getAlljsxxlx: 'pyfa/jslx/getAll',
  },

  /**
   * 审核流程
   */
  workflow: {
    // 分页查询审核流程信息
    findPage: 'pyfa/workflow/findPage',
    // 查询所有未发起的课程体系
    findNotStart: 'pyfa/workflow/findNotStart',
    // 分页查询审核人信息
    findPageShr: 'pyfa/workflow/findPageShr',
    // 发起课程体系流程
    addLcsl: 'pyfa/workflow/addLcsl',
  },

  /**
   * 文件上传下载
   */
  fileUrls: {
    uploadFile_icon: '/file/files/uploadFile',
    downloadFile: '/file/files/downloadFile',
  },

  kctxApply: {
    findPage: '/pyfa/kctxApply/findPage',
    save: '/pyfa/kctxApply/save',
  },
};
